import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { DeleteIcon } from '../../components/common/Icon/DeleteIcon';
import React from 'react';
import { FilterApi } from '../api';

type TableComponentProps = {
  pData: any[];
  contractsCpoNotAssigned: [];
  setContractsCpoNotAssigned: Function;
  setContractsUser: Function;
  forceUpdate: Function;
  cpoSelected: string;
};
// return table that show contracts of user already assigned and those will be assigned
export const TableComponent = ({
  pData,
  contractsCpoNotAssigned,
  setContractsCpoNotAssigned,
  setContractsUser,
  forceUpdate,
  cpoSelected,
}: TableComponentProps) => {
  if (pData.length === 0) {
    return <div style={{ textAlign: 'center' }}><Word value={'Pas de donnée !'} variant='h3' /></div>;
  }

  return (
    <div>
      <Word
        value="Contrats affectés à l'utilisateur"
        textStyle='titleSmall'
        variant='p'
        automatedTestId='id-user'
        className='fieldLabel'
      />
      <div style={{ overflowY: 'scroll', maxHeight: '100px' }}>
        <table style={{ textAlign: 'left', width: '100%', backgroundColor: '#FFFFFF', borderRadius: '15px' }}>
          <thead>
            <tr style={{ fontSize: '15px' }}>
              <th>CPO</th>
              <th>Contrat</th>
              <th></th>
            </tr>
          </thead>
          <tbody style={{ border: '1px solid #DCDCDC' }}>
            {pData.map((line) => {
              return (
                <tr key={line.contractId} style={{ fontSize: '12px' }}>
                  <td>{line.cpo}</td>
                  <td>{line.contractLabel}</td>
                  <td
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      if (cpoSelected === line.cpo) {
                        unassignedContract(
                          line,
                          contractsCpoNotAssigned,
                          pData,
                          setContractsCpoNotAssigned,
                          setContractsUser,
                          forceUpdate,
                        );
                      } else {
                        let contractsUserToUpdate = pData.filter(
                          (contract) => contract.contractId !== line.contractId,
                        );
                        setContractsUser(contractsUserToUpdate);
                        forceUpdate();
                      }
                    }}
                  >
                    <DeleteIcon data-testid='delete-icon' />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// unassigned a contract
export const unassignedContract = (
  pContract: any,
  pContractsCpoNotAssigned: any[],
  pContractsUser: any[],
  setContractsCpoNotAssigned,
  setContractsUser,
  forceUpdate,
) => {
  // update contracts list
  let contractsCpoNotAssignedToUpdate = pContractsCpoNotAssigned;
  contractsCpoNotAssignedToUpdate.push({
    contractId: pContract.contractId,
    contractLabel: pContract.contractLabel,
    contractCode: pContract.contractCode,
  });
  // sort list
  contractsCpoNotAssignedToUpdate.sort((a, b) =>
    a.contractLabel.localeCompare(b.contractLabel),
  );

  // update table of contracts assigned list
  let contractsUserToUpdate = pContractsUser.filter(
    (contract) => contract.contractId !== pContract.contractId,
  );

  // set new values
  setContractsCpoNotAssigned(contractsCpoNotAssignedToUpdate);
  setContractsUser(contractsUserToUpdate);
  // force to update dom with hook setter
  forceUpdate();
};

// function to save data for user
export const saveContracts = async (
  setLoading: Function,
  userSelected: { id: number },
  contractsUser: any[],
  toastSucess: React.MutableRefObject<any>,
  toastError: React.MutableRefObject<any>,
) => {
  setLoading(true);
  try {
    let contractsUpdated: any[] = [];
    let objects = {
      userId: userSelected.id,
      userContracts: contractsUpdated,
    };
    contractsUser.forEach((contract: any) => {
      contractsUpdated.push({
        contractId: contract.contractId,
        contractLabel: contract.contractLabel,
        contractCode: contract.contractCode,
        cpo: contract.cpo,
      });
    });

    const response = await FilterApi.updateUserContracts(objects);
    if (response.status === 200) {
      toastSucess.current?.show({
        severity: 'success',
        summary: 'Succès',
        detail: 'Contrat(s) ajouté(s)',
        life: 5000,
      });
    }
  } catch (e) {
    console.log(e);
    toastError.current?.show({
      severity: 'error',
      summary: 'Erreur',
      detail: "L'enregistrement a échoué. Veuillez réessayer.",
      life: 5000,
    });
  }
  setLoading(false);
};

// function to send news list of contracts of user by cpo
export const addContractToUser = (
  pContractsUser: any,
  pUserSelected: { name: string; id: number },
  pCpoSelected: string,
  pContractSelected: { name: string; contractCode: string; contractId: string },
  pContractsCpoNotAssigned: any[],
  setContractsCpoNotAssigned: Function,
  setContractsUser: Function,
  forceUpdate: Function,
) => {
  // update list of contracts to assign
  let contractsUserToUpdate = pContractsCpoNotAssigned.filter(
    (contract) => contract.contractId !== pContractSelected.contractId,
  );

  // assign contract to user (update table)
  let contractsUserUpdated: any[] = pContractsUser;
  pContractsUser.push({
    id: 0,
    userId: pUserSelected.id,
    cpo: pCpoSelected,
    contractLabel: pContractSelected.name,
    contractCode: pContractSelected.contractCode,
    contractId: pContractSelected.contractId,
  });

  setContractsCpoNotAssigned(contractsUserToUpdate);
  setContractsUser(contractsUserUpdated);
  // force to update dom with hook setter
  forceUpdate();
};

